import axios from 'axios';
import {
    getAuthHeader
} from "@/services/user.service.js";

export {
    GetKeywordsForContract,
    AddKeywordsToContract,
    DeleteKeywordFromContract
};

function GetKeywordsForContract(contractId, onSuccess, onError) {

    var headers = getAuthHeader();

    axios
        .get(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/keywords`,  headers)
        .then(response => {

            if (response.data && response.data.httpResultCode == 500) {
                onError(response);
            } else {
                onSuccess(response);
            }
        })
        .catch(error => {
            onError(error);
        });
}

function AddKeywordsToContract(contractId, keywordIds, onSuccess, onError) {

  var headers = getAuthHeader();

  axios
      .put(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/keywords/`, keywordIds, headers)
      .then(response => {
          if (response.data && response.data.httpResultCode == 500) {
              onError(response);
          } else {
              onSuccess(response);
          }
      })
      .catch(error => {
          onError(error);
      });
}

function DeleteKeywordFromContract(contractId, keywordId, onSuccess, onError) {

  var headers = getAuthHeader();

  axios
      .delete(process.env.VUE_APP_BASE_API_URL + `/contracts/${contractId}/keywords/${keywordId}`,  headers)
      .then(response => {
          if (response.data && response.data.httpResultCode == 500) {
              onError(response);
          } else {
              onSuccess(response);
          }
      })
      .catch(error => {
          onError(error);
      });
}

